module.exports = __webpack_public_path__ + "img/verify2.6329cd4a.png";